import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { MapPin } from 'lucide-react'

// Peta "geser utk pointing" (2026-07-22) -- pin SENGAJA bukan L.marker (yg ikut pindah pas map
// digeser), tapi ikon lucide yg di-absolute-position PAS DI TENGAH kontainer & pointer-events:none.
// Map di baliknya yg digeser (drag/pan Leaflet bawaan), pin diam di tengah -- pola umum "confirm
// location pin" (Gojek/Grab/Google Maps picker). Lat/long yg disimpan = titik tengah peta saat ini,
// dibaca dari event moveend.
const LokasiMap = forwardRef(function LokasiMap({ lat, lng, onChange }, ref) {
  const containerRef = useRef(null)
  const mapRef = useRef(null)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    if (!containerRef.current || mapRef.current) return
    const map = L.map(containerRef.current, { attributionControl: true }).setView(
      [Number(lat) || 0, Number(lng) || 0], 16
    )
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map)
    map.on('moveend', () => {
      const c = map.getCenter()
      onChangeRef.current(c.lat.toFixed(6), c.lng.toFixed(6))
    })
    mapRef.current = map
  }, [])

  useImperativeHandle(ref, () => ({
    setPosition(newLat, newLng) {
      mapRef.current?.setView([Number(newLat), Number(newLng)], 16)
    }
  }))

  return (
    <div style={{ position: 'relative', width: '100%', height: 220, borderRadius: 'var(--radius-sm)', overflow: 'hidden' }}>
      <div ref={containerRef} style={{ width: '100%', height: '100%' }} />
      <div style={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -100%)',
        pointerEvents: 'none', zIndex: 500, filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.35))'
      }}>
        <MapPin size={34} color="#e11d48" fill="#e11d48" strokeWidth={1.5} />
      </div>
    </div>
  )
})

export default LokasiMap
